<script>
import ListContainer from '@/containers/ListContainer'
export default {
  functional: true,
  components: {
    glist: ListContainer,
  },
  props: {
    source: String,
    form: Object,
    relations: Array,
    context: Object,
    onTabSelected: Function,
    hideAlert: {
      type: Function,
      default: () => {},
    },
  },
  render: (h, { props }) => {
    const { source, form, relations, context, hideAlert, onTabSelected } = props

    const doHideAlert = value => {
      hideAlert()
    }

    const errorAlert = form.hasError
      ? <v-alert
        value={form.showAlert}
        type="error"
        dismissible
        class="my-0"
        on-input={ doHideAlert }>
        { form.errors.message }
      </v-alert>
      : null

    const successAlert = form.saved
      ? <v-alert
        value={form.showAlert}
        type="success"
        dismissible
        class="my-0"
        on-input={ doHideAlert }>
          OK
      </v-alert>
      : null

    let tabs = relations.map((relation, idx) => (
      <v-tab
        key={relation.name}
        id={relation.name}
      >
        {relation.name}
      </v-tab>
    ))

    let tabItems = relations.map((relation, idx) => {
      let newContext = {
        id: context.id,
        customDispatch: relation.dispatch,
        origin: source,
      }
      return (<v-tab-item
        key={relation.name}
      >
        <v-card flat>
          <v-card-text>
            <ListContainer
              source={relation.source}
              list={relation}
              context={newContext}
            />
          </v-card-text>
        </v-card>
      </v-tab-item>)
    })

    return (
      <div>
        { errorAlert }
        { successAlert }
        <v-tabs
          color="purple darken-3"
          dark
          on-input={ v => onTabSelected(relations[v].source) }
        >
          { tabs }
          { tabItems }
        </v-tabs>
      </div>
    )
  },
}
</script>

<style scoped>
.card__text {
  padding: 0;
}

</style>
